import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import _ from 'lodash'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
// import { THEME } from 'src/config/config'
// import { ITopicItemFragment } from 'src/graphql/generated/hooks'
import { useUpdateQueryParams } from 'src/hooks/useUpdateQueryParams'
import { FilterOption, FilterOptionItem } from 'src/types'
import { getTaxonomyQueryFieldName } from 'src/utils/getTaxonomyQueryFieldName'

interface IFilterOptionsProps {
  className?: string
  filterOptions: FilterOption[]
}

interface IListItemData {
  title: string
  id: string
  name: string
  value?: Date | null | string
}

export const FilterOptions = ({ className = '', filterOptions }: IFilterOptionsProps) => {
  const router = useRouter()
  const { updateQueryParams } = useUpdateQueryParams()
  const [list, setList] = useState<IListItemData[]>([])

  const [filterPropsData, setFilterPropsData] = useState<FilterOption[]>([])
  const prevListLengthRef = useRef<number>(0)

  useEffect(() => {
    setFilterPropsData(filterOptions)
  }, [filterOptions])

  useEffect(() => {
    if (!router.isReady) return

    const temp: IListItemData[] = []

    if (router.query['keyword'] && router.query['keyword']?.length > 0) {
      if (!temp.some((value) => value.id === 'keyword')) {
        temp.push({
          id: 'keyword',
          name: (router.query['keyword'] as string) || '',
          title: 'keyword',
        })
      }
    }

    filterPropsData.map((item) => {
      const name = getTaxonomyQueryFieldName(item.title)
      if (name && router.query[name]) {
        //const paths = (router.query[name] as string).split('_')
        //const checks = paths[0].split(',')
        if (name === 'productType') {
          item.data.map((value) => {
            const filterOptionItem = value as FilterOptionItem
            if (filterOptionItem.allChildrenSelected) {
              temp.push({
                id: `${filterOptionItem.id}` || '',
                name: filterOptionItem.name || '',
                title: 'product type',
              })
            } else {
              filterOptionItem.children?.forEach((subItem) => {
                if (subItem.selected) {
                  const childrenPathId = filterOptionItem.id + '@@@@' + subItem.id
                  temp.push({
                    id: `${childrenPathId}` || '',
                    name: subItem.name || '',
                    title: 'product type',
                  })
                }
              })
            }
          })
        } else {
          const array = (router.query[name] as string).split(',')
          item.data.map((option) => {
            if (array.includes(option.id)) {
              temp.push({
                id: option.id,
                name: option.name,
                title: item.title,
              })
            }
          })
        }
      }

      if (name === 'date') {
        if (router.query['startDate']) {
          const d = new Date(Number(router.query['startDate']))
          temp.push({
            id: '10012',
            value:
              d.getMonth() + 1 + '/' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + '/' + d.getFullYear(),
            title: 'startDate',
            name: 'From',
          })
        }
        if (router.query['endDate']) {
          const d = new Date(Number(router.query['endDate']))
          temp.push({
            id: '10013',
            value:
              d.getMonth() + 1 + '/' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + '/' + d.getFullYear(),
            title: 'endDate',
            name: 'To',
          })
        }
      }
    })
    /* if (router.query['startDate']) {
      const d = new Date(Number(router.query['startDate']))
      temp.push({
        id: '111',
        name: d.getMonth() + 1 + '/' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + '/' + d.getFullYear(),
        title: 'startDate',
      })
    }
    if (router.query['endDate']) {
      const d = new Date(Number(router.query['endDate']))
      temp.push({
        id: '111',
        name: d.getMonth() + 1 + '/' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + '/' + d.getFullYear(),
        title: 'endDate',
      })
    } */
    setList(temp)

    // if (temp.length === 0 && router.query.sort !== undefined) {
    //   updateQueryParams({ sort: undefined })
    // }

    const hadFilters = prevListLengthRef.current > 0
    const nowEmpty = temp.length === 0

    if (hadFilters && nowEmpty && router.query.sort !== undefined) {
      updateQueryParams({ sort: undefined })
    }
    prevListLengthRef.current = temp.length
  }, [router.isReady, router.query, filterPropsData])

  const onRemoveFilter = (item: IListItemData) => {
    const isLastFilter = list.length === 1
    const paramsToUpdate: Record<string, string | undefined> = isLastFilter ? { sort: undefined } : {}

    if (item.id === 'keyword') {
      updateQueryParams({ ...paramsToUpdate, keyword: undefined })
    } else {
      const name = getTaxonomyQueryFieldName(item.title)
      if (!name) return
      const temp: string[] = []
      if (name === 'productType') {
        const avoidItem = item
        for (const item of filterPropsData) {
          const name = getTaxonomyQueryFieldName(item.title)
          if (name && router.query[name]) {
            if (name === 'productType') {
              for (const value of item.data) {
                const filterOptionItem = value as FilterOptionItem
                if (avoidItem && avoidItem?.name === filterOptionItem?.name) {
                  continue
                }
                filterOptionItem.children?.forEach((subItem) => {
                  if (subItem.selected && avoidItem?.name != subItem?.name) {
                    const childrenPathId = filterOptionItem.id + '@@@@' + subItem.id
                    if (childrenPathId) {
                      temp.push(childrenPathId)
                    }
                  }
                })
              }
            }
          }
        }
      } else {
        const index = list.indexOf(item)
        if (index !== -1) {
          list.splice(index, 1)
        }
        list.map((i) => {
          if (i.title === item.title) temp.push(i.id)
        })
      }
      const query = temp.join(',')
      updateQueryParams({ ...paramsToUpdate, [name]: query || undefined })
    }
  }

  const onClear = () => {
    const paramsToRemove: Record<string, string | undefined> = {}
    paramsToRemove['keyword'] = undefined
    paramsToRemove['sort'] = undefined
    filterPropsData.forEach((item) => {
      const name = getTaxonomyQueryFieldName(item.title)
      if (name) {
        if (name === 'date') {
          paramsToRemove['startDate'] = undefined
          paramsToRemove['endDate'] = undefined
        }

        paramsToRemove[name] = undefined
      }
    })
    updateQueryParams(paramsToRemove)
  }

  const changeTitle = (title: string) => {
    if (title === 'startDate') return 'Published after'
    if (title === 'endDate') return 'Published before'
    return title
  }
  const formatedFilter = (item: any) => {
    if (item?.value) {
      return item.value
    } else if (item?.name.includes('&')) {
      return _.startCase(item.name.replace(/&/g, ' ampersandsym ')).replace(/ Ampersandsym /g, ' & ')
    }
    return item.name
  }

  return (
    <div className={cn(className, list.length > 0 && 'flex flex-wrap mb-1.5')}>
      {list.map((item, index) => {
        return (
          <div
            key={index}
            className="min-h-[1.25rem] md:h-[1.25rem] bg-fog text-textdark text-[0.8125rem] font-primary font-bold items-center text-center rounded-lg mt-1.5 mr-4 px-1 flex"
          >
            <div className="mr-1">{_.capitalize(changeTitle(item.title)) + ': ' + formatedFilter(item)}</div>
            <button key={index} onClick={() => onRemoveFilter(item)} className="flex items-center">
              <IonIcon name="close-circle" className="text-[0.8125rem] bg-fog" />
            </button>
          </div>
        )
      })}
      {list.length > 0 && (
        <button onClick={onClear}>
          <div className="text-textdark text-[0.8125rem] font-primary font-bold flex items-center mt-1.5">
            <u>Clear Filters</u>
          </div>
        </button>
      )}
    </div>
  )
}
